import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from 'ui/constants';

const HeaderPlaceholder = styled.div`
  margin: calc(1em + 2px) 16px 4px;
  width: 100px;
  height: 24px;
`;

const DescriptionPlaceholder = styled.div`
  margin: 0 16px 1em;
  width: 400px;
  height: 13px;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 13.5em;
  min-width: 13.5em;
  background-color: ${colors.white};
  border-radius: 4px;
  box-shadow: 0 2px 5px 0 rgba(51, 51, 51, 0.25);
  min-height: 160px;
  margin-right: 20px;
`;

const CardWrapper = styled.div`
  display: flex;
  margin: 1em;
`;

const NumericalWrapper = styled.div`
/* stylelint-disable */
  ${CardContainer} {
    margin: 24px 0 24px 15px;
  }
/* stylelint-enable */
`;

function Card() {
  return (
    <CardContainer>
    </CardContainer>
  );
}

function SwiperPlaceholder() {
  return (
    <div>
      <HeaderPlaceholder />
      <DescriptionPlaceholder />

      <CardWrapper>
        <Card />
        <Card />
        <Card />
      </CardWrapper>

      <HeaderPlaceholder />
      <DescriptionPlaceholder />

      <CardWrapper>
        <Card />
        <Card />
        <Card />
      </CardWrapper>

      <HeaderPlaceholder />
      <DescriptionPlaceholder />

      <CardWrapper>
        <Card />
        <Card />
        <Card />
      </CardWrapper>
    </div>
  );
}

export const NumericalPlaceholder = () => (
  <NumericalWrapper>
    <HeaderPlaceholder />
    <DescriptionPlaceholder />

    <Card />
    <Card />
    <Card />
    <Card />
    <Card />
    <Card />
  </NumericalWrapper>
);

export default SwiperPlaceholder;
